import React, { useContext } from 'react';

import { isShellArticle, shouldShowTaboola } from 'lib/article';

import Taboola from 'components/Taboola';
import { BreakpointContext } from 'lib/ContextTypes';

/**
 * Renders the Taboola widget within an article body.
 *
 * @param {object} props - The component props.
 * @param {boolean} [props.isRail=false] - Whether the Taboola widget is in the rail.
 * @param {object} props.article - The article data object.
 * @param {boolean} [props.showTaboola=false] - Whether to show the Taboola widget.
 */
export const BodyTaboola = ({
  isRail = false,
  article,
  showTaboola = false,
}) => {
  const { isS } = useContext(BreakpointContext);

  if (isShellArticle(article)) {
    return null;
  }

  const { id, url, ecommerceEnabled } = article;

  const className = isRail && ecommerceEnabled ? 'dn-l' : null;

  if (!shouldShowTaboola(article, showTaboola, isS)) {
    return null;
  }

  return (
    <Taboola
      id={id}
      canonicalUrl={url.canonical || url.primary}
      isRail={isRail}
      className={className}
      ecommerceEnabled={ecommerceEnabled}
    />
  );
};
